<template>
	<div>
		<PageHeader :tab="1" :current="navTab" @changeFunc="navTabFunc"></PageHeader>
		<div class="mainW">
			<div class="flex-start banner mt-20">
				<div class="left tc mr-10">
					<ul v-if="navTab == 0 || navTab == 1 || navTab == 2 || navTab == 3">
						<router-link tag="li" :to="{ path: '/vip' }" class="cursor box">
							会员中心
						</router-link>
						<router-link tag="li" :to="{ path: '/course?type=1&name=ptbk&code=' + code }" class="cursor box">
							拼团报课
						</router-link>
						<router-link tag="li" :to="{ path: '/score' }" class="cursor box">
							积分签到
						</router-link>
						<router-link tag="li" :to="{ path: '/means?code=' + code }" class="cursor box">
							资料领取
						</router-link>
						<router-link tag="li" :to="{ path: '/course?type=2&name=mfhk' }" class="cursor box">
							限时免费
						</router-link>
					</ul>
					<ul v-else>
						<router-link tag="li" :to="{ path: '/topic?code=' + code }" class="cursor box">
							模拟题库
						</router-link>
						<router-link tag="li" :to="{ path: '/course?type=8&code=' + code }" class="cursor box">
							直播课程
						</router-link>
						<router-link tag="li" :to="{ path: '/means?code=' + code }" class="cursor box">
							资料领取
						</router-link>
						<router-link tag="li" :to="{ path: '/score' }" class="cursor box">
							积分签到
						</router-link>
					</ul>
				</div>
				<div class="right">
					<el-carousel :interval="5000" arrow="always">
						<el-carousel-item v-for="(img, i_) in banner" :key="i_">
							<img :src="img.image_pc" alt="" @click="openView(img)">
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<!-- 首页 dataArr:直播预告 tuiClass:推荐课程 groupArr：拼团报课 bookArr:电子书-->
			<Home v-if="navTab == 0" :dataProp="dataArr" :dataGroup="groupArr" :dataHomeJing="homeJingClass"
				:dataClass="tuiClass" :dataBook="bookArr"></Home>

			<!-- 采购 供应链 招投标 -->
			<!-- dataArr:直播预告 freeClass：免费好课 jingClass:精品推荐 groupArr：拼团报课 remenClass：热门推荐-->

			<Class1 :propTab="navTab" :dataProp="dataArr" :dataGroup="groupArr" :dataClass="tuiClass" :dataJing="jingClass"
				:dataFree="freeClass" :dataHot="remenClass" :propCode="code"
				v-else-if="navTab == 1 || navTab == 2 || navTab == 3"></Class1>

			<!-- dataArr:直播预告 zxClass：专项课程 kdClass：考点精讲 xitiClass：习题练习 -->

			<Class2 :dataProp="dataArr" :propCode="code" :dataZxClass="zxClass" :dataKdClass="kdClass"
				:dataXtClass="xitiClass" :dataXinde="xinde" v-else-if="navTab == 4 || navTab == 5 || navTab == 6 || navTab == 7"></Class2>
		</div>
		<PageFooter></PageFooter>
	</div>
</template>

<script>
import PageHeader from '@/components/PageHeader/index.vue'
import PageFooter from '@/components/PageFooter/index.vue'
// 首页
import Home from './components/home.vue'
import Class1 from './components/class1.vue'
import Class2 from './components/class2.vue'
export default {
	components: {
		PageHeader,
		PageFooter,
		Home,
		Class1,
		Class2
	},
	name: 'index',
	data() {
		return {
			navTab: 0, // 导航，默认首页
			keyword: '', // 关键字
			banner: [], // 轮播图
			code: '', // 默认全部code，采购课程=CG，供应链课程=GYL，招投标课程=ZTB，CPPM课程=CPPM，SCPM课程=SCPM，PMP课程=PMP 中级经济师=JJS
			live_state: 'live_state', // 默认全部live_state，未开始=not_started，直播中=in_progress，已结束=end
			viewing_restrictions: 'viewing_restrictions', // 课程方式，默认全部，免费课程=free，付费课程=pay，加密课程=encryption
			page: 1,
			per_page: 2,
			dataArr: [], // 直播预告
			tuiClass: {}, // 推荐课程
			homeJingClass: {},//首页精品推荐
			jingClass: {}, // 推荐课程
			remenClass: {}, // 热门推荐
			freeClass: {}, // 免费好课
			groupArr: [], // 拼团报课
			bookArr: [], // 电子书
			zxClass: {}, // 专项课程
			kdClass: {}, // 考点精讲
			xitiClass: {}, // 习题练习
			xinde: [], // 学员心得
			tabId: 0
		}
	},
	created() {
		this.tabId = this.$route.query.id ? this.$route.query.id : 0
		this.navTab = this.tabId * 1
		this.getPropFunc(this.navTab)
	},
	methods: {
		openView(item) {
			if (item.open_url == null) {
				return;
			}
			this.$router.push('/details?id='+item.open_url+'&propType=video')
			
		},
		// 获取轮播图
		getBanner() {
			let that = this
			let data = {
				code: that.code == '' ? 'HOME' : that.code
			}
			that.$get('base/banner', data).then(res => {
				if (res.code == 1) {
					that.banner = res.data
				}
			})
		},
		// 点击导航
		navTabFunc(e) {
			this.navTab = e
			// console.log(e)
			this.getPropFunc(e)
		},
		getPropFunc(e) {
			let that = this
			that.live_state = 'not_started'
			switch (e) {
				case 0:
					// 首页
					that.code = ''// 默认全部code，采购课程=CG，供应链课程=GYL，招投标课程=ZTB，CPPM课程=CPPM，SCPM课程=SCPM，PMP课程=PMP  中级经济师=JJS
					that.getGroup()
					that.getTui()
					that.getJingPin()
					that.getBook()
					break
				case 1:
					// 采购课程
					that.code = 'CG'
					that.getGroup()
					that.getTui()
					that.getFreeClass()
					that.getJingPin()
					that.getHot()
					break
				case 2:
					// 供应链课程
					that.code = 'GYL'
					that.getGroup()
					that.getTui()
					that.getFreeClass()
					that.getJingPin()
					that.getHot()
					break
				case 3:
					// 招投标课程
					that.code = 'ZTB'
					that.getGroup()
					that.getTui()
					that.getFreeClass()
					that.getJingPin()
					that.getHot()
					break
				case 4:
					// CPPM课程
					that.code = 'CPPM'
					console.log(4)
					that.getPlateClass()
					that.getKdClass()
					that.getXitiClass()
					that.getXinde()
					break
				case 5:
					// SCPM课程
					that.code = 'SCPM'
					that.getPlateClass()
					that.getKdClass()
					that.getXitiClass()
					that.getXinde()
					break
				case 6:
					// PMP课程
					that.code = 'PMP'
					that.getPlateClass()
					that.getKdClass()
					that.getXitiClass()
					that.getXinde()
					break
				case 7:
					// 中级经济师
					that.code = 'JJS'
					that.getPlateClass()
					that.getKdClass()
					that.getXitiClass()
					that.getXinde()
					break
				default:
			}
			that.getBanner()
			// 直播预告
			that.getData()
		},
		// 首页直播预告
		getData() {
			let that = this
			let data = {
				code: that.code,
				tuijian: 'home',
				page: that.page,
				per_page: that.per_page,
				sort: 'sort',
				order: 'asc'
			}
			// 直播预告
			that.$get('course_live_broadcast_preview/query', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length >= 4) {
						that.dataArr = res.data.data.slice(0, 4)
					} else {
						that.dataArr = res.data.data
					}
					if (that.dataArr.length > 0) {
						for (let key in that.dataArr) {
							if (!Array.isArray(that.dataArr[key].main_drawing_pc)) {
								that.dataArr[key].main_drawing_pc = that.dataArr[key].main_drawing_pc.split(',')
							}
						}
					}
				}
			})
		},
		// 首页拼团报课
		getGroup() {
			let that = this
			let data = {
				code: that.code,
				// type: 'live',
				is_home: 1,
				page: 1,
				per_page: 10,
				sort: 'sort',
				order: 'asc'
			}
			that.$get('home/group_by', data).then(res => {
				if (res.code == 1) {
					that.groupArr = res.data
				}
			})
		},
		// 视频课-推荐课程
		getTui() {
			let that = this
			let data = {
				code: that.code,
				page: 1,
				per_page: 4,
				tuijian: 'home_tuijian',
				sort: 'sort',
				order: 'asc'
			}
			that.$get('video_lesson/recommend_list', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing_pc)) {
								res.data.data[key].main_drawing = res.data.data[key].main_drawing_pc.split(',')
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing_pc.split(',')
							}
						}
					}
					that.tuiClass = res.data
				}
			})
		},
		// 精品推荐
		getJingPin() {
			let that = this
			let data = {
				code: that.code,
				page: 1,
				per_page: 4,
				tuijian: that.code == '' ? 'home_jingpin' : 'section_jingpin', // 是否精品推荐
				sort: 'sort',
				order: 'asc'
			}
			that.$get('video_lesson/recommend_list', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing_pc)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing_pc.split(',')
							}
						}
					}
					that.jingClass = res.data
					that.homeJingClass = res.data
				}
			})
		},
		// 热门推荐
		getHot() {
			let that = this
			let data = {
				code: that.code,
				// type:'free',//免费课程=free，付费课程=pay，加密课程=encryption
				page: 1,
				per_page: 4,
				tuijian: 'section_remen', // remen
				sort: 'sort',
				order: 'asc'
			}
			that.$get('video_lesson/recommend_list', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing_pc)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing_pc.split(',')
							}
						}
					}
					that.remenClass = res.data
				}
			})
		},
		// 免费好课
		getFreeClass() {
			let that = this
			let data = {
				code: that.code,
				viewing_restrictions: 'free', // 免费课程=free，付费课程=pay，加密课程=encryption
				page: 1,
				per_page: 4,
				tuijian: 'section_mianfei',
				sort: 'sort',
				order: 'asc'
			}
			that.$get('video_lesson/recommend_list', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing_pc)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing_pc.split(',')
							}
						}
					}
					that.freeClass = res.data
				}
			})
		},
		// 电子书
		getBook() {
			let that = this
			let data = {
				home_recommend: 1, // 是否只查询首页 1：是 0否
				page: 1,
				per_page: 10,
				sort: 'id',
				order: 'asc'
			}
			that.$get('ebook/query', data).then(res => {
				if (res.code == 1) {
					that.bookArr = res.data.data
					if (that.bookArr.length > 0) {
						for (let key in that.bookArr) {
							if (!Array.isArray(that.bookArr[key].main_drawing_pc)) {
								that.bookArr[key].main_drawing_pc = that.bookArr[key].main_drawing_pc.split(',')
							}
						}
					}
				}
			})
		},
		// 专项课程/api/video_lesson/plate_classify
		// video_lesson/recommend_list
		getPlateClass() {
			let that = this
			let data = {
				code: that.code,
				plate_classify: 'zxkc', // 专项课程=zxkc，考点精讲=kdjx，习题练习=xtlx
				page: 1,
				per_page: 4,
				sort: 'sort',
				order: 'asc',
				tuijian: 'section_home'
			}

			that.$get('video_lesson/plate_classify', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing.split(',')
							}
						}
					}
					that.zxClass = res.data
					console.log(that.zxClass, 'that.zxClass')
				}
			})
		},
		// 考点精讲
		getKdClass() {
			let that = this
			let data = {
				code: that.code,
				plate_classify: 'kdjj', // 专项课程=zxkc，考点精讲=kdjj，习题练习=xtlx
				page: 1,
				per_page: 4,
				sort: 'sort',
				order: 'asc',
				tuijian: 'section_home'
			}
			that.$get('video_lesson/plate_classify', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing.split(',')
							}
						}
					}
					that.kdClass = res.data
				}
			})
		},
		// 习题练习
		getXitiClass() {
			let that = this
			let data = {
				code: that.code,
				plate_classify: 'xtlx', // 专项课程=zxkc，考点精讲=kdjx，习题练习=xtlx
				page: 1,
				per_page: 4,
				sort: 'sort',
				order: 'asc',
				tuijian: 'section_home'
			}
			that.$get('video_lesson/plate_classify', data).then(res => {
				if (res.code == 1) {
					if (res.data.data.length > 0) {
						for (let key in res.data.data) {
							if (!Array.isArray(res.data.data[key].main_drawing)) {
								res.data.data[key].main_drawing_pc = res.data.data[key].main_drawing.split(',')
							}
						}
					}
					that.xitiClass = res.data
				}
			})
		},
		// 学员心得/api/
		getXinde() {
			let that = this
			let data = {
				code: that.code,
				is_tuijian: 1,
				page: 1,
				per_page: 4
			}
			that.$get('base/experience', data).then(res => {
				if (res.code == 1) {
					that.xinde = res.data
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.banner {
	.left {
		width: 230px;
		background-color: #fff;
		border-radius: 10px;

		li {
			border-bottom: 1px solid #EEEEEE;
			line-height: 63px;
			cursor: pointer;

			&:nth-last-of-type(1) {
				border-bottom: 0;
			}
		}

	}

	.right {
		width: 960px;
		border-radius: 8px;
		-webkit-border-radius: 8px;
		-moz-border-radius: 8px;
		overflow: hidden;
	}
}

/deep/.el-carousel__container {
	height: 320px;
}

/deep/.el-scrollbar__wrap {
	overflow-x: auto;
	height: calc(100% + 20px);
}

/deep/.el-scrollbar__view {
	white-space: nowrap;
	display: inline-block;
}

/deep/.el-scrollbar__view {
	height: 200px;
}

.box {
	letter-spacing: 1px;
	font-size: 17px;
	transition: all 0.3s ease;
	/*添加过渡效果*/
}

.box:hover {
	font-weight: 600 !important;
	font-size: 19px;
	color: #00479d;
	/*鼠标放上去后背景色变为红色*/
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue